function ShuffleIcon({
  size = 36,
  className = '',
  onClick = (event) => {},
  filled = false
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
  filled?: boolean;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 25) / 24}
        viewBox='0 0 24 25'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15 3.5C15 2.94772 15.4477 2.5 16 2.5H21C21.5523 2.5 22 2.94772 22 3.5V8.5C22 9.05228 21.5523 9.5 21 9.5C20.4477 9.5 20 9.05228 20 8.5V4.5H16C15.4477 4.5 15 4.05228 15 3.5Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.7071 2.79289C22.0976 3.18342 22.0976 3.81658 21.7071 4.20711L4.70711 21.2071C4.31658 21.5976 3.68342 21.5976 3.29289 21.2071C2.90237 20.8166 2.90237 20.1834 3.29289 19.7929L20.2929 2.79289C20.6834 2.40237 21.3166 2.40237 21.7071 2.79289Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21 15.5C21.5523 15.5 22 15.9477 22 16.5V21.5C22 22.0523 21.5523 22.5 21 22.5H16C15.4477 22.5 15 22.0523 15 21.5C15 20.9477 15.4477 20.5 16 20.5H20V16.5C20 15.9477 20.4477 15.5 21 15.5Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.2929 14.7929C14.6834 14.4024 15.3166 14.4024 15.7071 14.7929L21.7071 20.7929C22.0976 21.1834 22.0976 21.8166 21.7071 22.2071C21.3166 22.5976 20.6834 22.5976 20.2929 22.2071L14.2929 16.2071C13.9024 15.8166 13.9024 15.1834 14.2929 14.7929Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.29289 3.79289C3.68342 3.40237 4.31658 3.40237 4.70711 3.79289L9.70711 8.79289C10.0976 9.18342 10.0976 9.81658 9.70711 10.2071C9.31658 10.5976 8.68342 10.5976 8.29289 10.2071L3.29289 5.20711C2.90237 4.81658 2.90237 4.18342 3.29289 3.79289Z'
        />
      </svg>
    </span>
  );
}

export default ShuffleIcon;
